import React from 'react';
import {observer} from 'mobx-react-lite';
import intl from 'react-intl-universal';

import {serverAvailabilityStore} from '@stores/serverConnection/serverAvailability';
import {ServerConnectionNotice as ServerConnectionNoticePure} from '../../components/ServerConnectionNotice/ServerConnectionNotice';

export const ServerConnectionNotice = observer(() => {
    if (!serverAvailabilityStore.shouldShowOfflineNotice) {
        return null;
    }

    return (
        <ServerConnectionNoticePure
            title={intl.get('server_connection.offline.title').d('Server connection unavailable')}
            message={intl.get('server_connection.offline.message').d('Reconnecting. Cached data remains visible, but new changes may not sync yet.')}
        />
    );
});
